<template>
  <Modal
    v-model="modalVisible"
    :cancelText="numEligibleSystems ? 'cancel' : ''"
    :handleMainAction="handleMainAction"
    headerText="Disable Multi-factor Authentication on Devices"
    :mainActionText="numEligibleSystems ? 'disable' : 'ok'"
  >
    <div v-if="numEligibleSystems">
      <p>
        {{ numEligibleSystems }} of {{ selectedItems.length }} selected
        devices have MFA enabled.
      </p>
      <p>
        Are you sure you'd like to disable MFA on the selected devices?
      </p>
    </div>
    <div v-else>
      <p>
        Selected devices do not have MFA enabled.
      </p>
    </div>
  </Modal>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import _ from 'lodash';
import mfaEnrollmentMixin from 'components/mixins/mfaEnrollmentMixin';
import mfaModalMixin from 'components/Modal/mfaModals/mfaModalMixin';
import pluralize from 'pluralize';

const { error, success } = Constants.default;

export default {
  name: 'SystemDisableMFAModal',

  mixins: [
    mfaEnrollmentMixin,
    mfaModalMixin,
  ],

  computed: {
    ...mapGetters('SystemCollection', {
      ineligibleSystems: 'getSystemsIneligibleForMFADisablement',
      selectedItems: 'getSelectedItems',
    }),

    numEligibleSystems() {
      return this.selectedItems.length - this.ineligibleSystems.length;
    },
  },

  methods: {
    ...mapActions('SystemCollection', [
      'unselectItems',
      'updateItems',
    ]),

    /**
     * Disables MFA for systems that are selected
     */
    disableMFAForSystems() {
      const numSystems = this.selectedItems.length;
      this.updateItems({
        ids: this.selectedItems,
        attributes: { allowMultiFactorAuthentication: false },
      })
        .then((response) => {
          let notifyType;
          let notifyMessage;
          if (_.get(response, 'numSuccess')) {
            notifyType = success;
            notifyMessage = (numSystems === 1)
              ? '1 system was successfully updated.'
              : `${response.numSuccess} of ${numSystems} systems were successfully updated.`;
            this.unselectItems({ ids: this.selectedItems });
          } else {
            notifyType = error;
            notifyMessage = `Error updating ${pluralize('system', numSystems)}.`;
          }
          notify(notifyType, notifyMessage);
        });
    },

    /**
     * Executes when the user clicks the main action button in the modal.
     * Disables MFA for the selected systems. If there are systems that cannot have MFA
     * disabled (already disabled systems), they will be unselected.
     */
    handleMainAction() {
      if (!this.numEligibleSystems) {
        this.hideModal();
        return;
      }

      try {
        this.hideModal();
        if (this.ineligibleSystems.length) {
          this.unselectItems({ ids: this.ineligibleSystems.map(item => item.id) });
        }
        this.disableMFAForSystems();
      } catch (err) {
        notify(error, err.message);
      }
    },
  },
};
</script>
